import { Component, inject, Inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { NotificationComponent } from '../notification/notification.component'; 

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [MatIcon,MatTooltip,NotificationComponent],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent {
  router = inject(Router);
  private localStorage=inject(AesEncDecService)
  logout() {
    // Remove the access token cookie
    this.localStorage.clearData();
    this.router.navigateByUrl('login');
    
 
  }

  private deleteCookie(name: string) {
    document.cookie = name + '=; Max-Age=0; path=/; domain=' + window.location.hostname;
  }
}
